import styled from 'styled-components'

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  background: linear-gradient(to right, #1b2330 0%, rgb(13, 17, 24) 100%);
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Wrapper = styled.div`
  background: white;
  border-radius: 30px;
  width: 70%;
  height: 25rem;

  @media only screen and (min-width: 1090px) {
    display: flex;
    background: white;
    min-width: 60rem !important;
    max-width: 1200px;
    border-radius: 30px;
  }
`

export const TextCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 60%;
  background: linear-gradient(to right, #1b2330 0%, rgb(13, 17, 24) 100%);
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  box-sizing: border-box;

  h1 {
    display: flex;
    justify-content: center;
    color: white;
    font-size: 4rem;
    margin-left: 5rem;
  }

  h3 {
    color: white;
    margin-left: 5rem;
    width: 70%;
  }

  @media only screen and (max-width: 1090px) {
    display: none;
  }
`

export const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;

  p {
    text-align: center;

    b {
      color: #020202;
      cursor: pointer;
    }
  }

  .img-direcao {
    img {
      width: 80%;
      margin-top: 3rem;
      margin-right: 11px;
    }
    display: flex;
    justify-content: center;
    align-items: center;
  }

  form {
    margin-left: 1rem;
    margin-top: 2.5rem;
    width: 80%;
    height: 40%;
    display: flex;
    flex-direction: column;
    align-items: center;
    border: none;

    input {
      color: rgb(74, 74, 74);
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      padding: 15px;
      width: 70%;
      border: none;
      background-color: #252f3e;
      border-radius: 20px;
      margin: 2rem auto;

      &:disabled {
        background-color: #7c818a;
        cursor: not-allowed;
      }
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 1090px) {
    width: 550px;

    form {
      margin-left: 3.5rem;
    }

    button {
      margin-left: 5rem;
    }

    p {
      padding-left: 11rem;
    }
  }

  @media only screen and (min-width: 1090px) {
    padding-left: 5rem;
    margin-bottom: 1rem;

    form {
      width: 90%;

      input {
        width: 100% !important;
      }
    }

    button {
      margin-left: 2.6rem;
    }

    p {
      padding-left: 1.5rem;
    }
  }
`
